import { RequestState } from "common/RequestState";
import reduceReducers from "reduce-reducers";

/**
 * Provides a reducer that can handle multiple data items, and a singular request per data item
 * The request can go through the stages -> NotRequested -> InProgress -> Finished/Failed (🔄)
 * requestStateHelper should be used to check the state of requests during component rendering
 *
 * Therefore, @requestedActionType - @receivedActionType - @failedActionType actions are required
 * Optionally @resetActionType will reset the key to NotRequested so actions may be repeated
 * Optionally @customReducer can be implemented to extend the given functionality
 *
 * _requestState & correlationId are reserved names that are merged into the payload from the api
 * correlationId can be used in SUMOLogic to track down the nature of errors
 */
export const createGenericListItemReducer = (
  requestedActionType,
  receivedActionType,
  failedActionType,
  resetActionType,
  customReducer,
  customInitialState
) => {
  const initialState = {};
  const genericListItemReducer = (state = customInitialState || initialState, action) => {
    //Action id must be supplied
    if (!action.id) {
      return state;
    }
    switch (action.type) {
      case requestedActionType:
        return {
          ...state,
          [action.id]: { ...state[action.id], ...action.payload, _requestState: RequestState.InProgress }
        };
      case receivedActionType:
        return {
          ...state,
          [action.id]: { ...state[action.id], ...action.payload, _requestState: RequestState.Finished }
        };
      case failedActionType:
        return {
          ...state,
          [action.id]: {
            ...state[action.id],
            ...action.payload,
            _requestState: RequestState.Failed,
            correlationId: action.correlationId
          }
        };
      case resetActionType:
        return {
          ...state,
          [action.id]: { _requestState: RequestState.NotRequested }
        };
      default:
        return state;
    }
  };

  return customReducer ? reduceReducers(genericListItemReducer, customReducer) : genericListItemReducer;
};
